import { userPermissionsEnum } from '../../../../Core/Users/enums/user-permissions.enum';
import { NavItem, NavItemType } from '../../../../Common/Layout/components/Navbar/navbar.component';
import { ResearchRequestDialogComponent } from '../../../../Common/Dialogs/components/ResearchRequestDialog/research-request-dialog.component';

export const newsDirectSupportNav: NavItem[] =
[
    {
        label: 'Core.navigation.support.supportAndTraining',
        icon: 'fa-duotone fa-regular fa-headset',
        id: 'primaryNavSupport',
        collapsed: true,
        items: [
            {
                label: 'Core.navigation.support.contactSupport',
                type: NavItemType.contactSupport,
                id: 'primaryNavContactSupport'
            },
            {
                label: 'Core.navigation.support.supportLibrary',
                url: 'https://www.agilitypr.com/support/',
                id: 'primaryNavSupportLibrary'
            },
            {
                label: 'Core.navigation.support.submitRequest',
                type: NavItemType.dialog,
                permissions: [
                    userPermissionsEnum.targeting,
                    userPermissionsEnum.advancedTargeting
                ],
                dialogReference: ResearchRequestDialogComponent,
                id: 'primaryNavSubmitResearchRequest',
            }
        ]
    },
    {
        label: 'Core.navigation.newsDirect.support',
        icon: 'fa-duotone fa-regular fa-circle-question',
        id: 'primaryNavNewsDirect',
        collapsed: true,
        items: [
            {
                label: 'Core.navigation.newsDirect.home',
                url: 'http://www.newsdirect.com/',
                id: 'primaryNavNewsDirectHome'
            },
            {
                label: 'Core.navigation.newsDirect.newsHub',
                url: 'https://newsdirect.com/news',
                id: 'primaryNavNewsDirectNews'
            }
        ]
    }
];
